define([
    'moment'
], (moment) => {
    'use strict';
    return (date, format = 'ddd, MMM D') => moment(date).format(format);
});
